import React, { useMemo } from "react";

import connect from "../../../../../../i18n/connect";
import Option from "./Option";
import PLAN_NAMES from "../../Plans/utils/planNames";

const PlanOptions = ({
  count = 50,
  translate,
  translationExists,
  availablePlans = []
}) => {
  return useMemo(() => {
    const options = [];

    for (let i = 1; i <= count; i++) {
      const title = `lp_plan-table_row-${i}_title`;
      const translatedTitle = translate(title);

      if (!translationExists(title) || translatedTitle === "") {
        continue;
      }

      options.push(
        <tr key={translatedTitle}>
          <td
            dangerouslySetInnerHTML={{ __html: translatedTitle }}
            className={"min-w-36"}
          />
          {availablePlans.map(name => {
            switch (name) {
              case PLAN_NAMES.START: {
                return (
                  <td key={name}>
                    <Option
                      value={translate(`lp_plan-table_row-${i}_freemium`)}
                    />
                  </td>
                );
              }
              case PLAN_NAMES.PRO: {
                return (
                  <td key={name}>
                    <Option value={translate(`lp_plan-table_row-${i}_pro`)} />
                  </td>
                );
              }
              case PLAN_NAMES.PREMIUM: {
                return (
                  <td key={name}>
                    <Option
                      value={translate(`lp_plan-table_row-${i}_premium`)}
                    />
                  </td>
                );
              }
              case PLAN_NAMES.INSIDER: {
                return (
                  <td key={name}>
                    <Option
                      value={translate(`lp_plan-table_row-${i}_insider`)}
                    />
                  </td>
                );
              }
              default: {
                return null;
              }
            }
          })}
        </tr>
      );
    }

    return options;
  }, [count, availablePlans]);
};

export default connect()(PlanOptions);
